import { Spinner } from '@/components/ui/kibo-ui/spinner';
import { cn } from '@/lib/utils';

interface FullPageSpinnerProps {
  className?: string;
}

export function FullPageSpinner({ className }: FullPageSpinnerProps) {
  return (
    <div
      className={cn(
        'flex h-screen w-full items-center justify-center',
        className
      )}
    >
      <Spinner size="large" className="mx-0" />
    </div>
  );
}